function toggleWidgets() {
  const cartDrawer = document.querySelector('cart-drawer');
  const menuDrawer = document.querySelector('menu-drawer');
  const floatingIcons = document.getElementById('floating-icons-slider');

  if (!floatingIcons ) return;

  // Check if cart-drawer is open and active (using attributes)
  const cartDrawerOpen = cartDrawer && cartDrawer.hasAttribute('open') && cartDrawer.hasAttribute('active');
  // Check if menu-drawer is open and active (using attributes)
  const menuDrawerOpen = menuDrawer && menuDrawer.hasAttribute('open') && menuDrawer.hasAttribute('active');

  if (cartDrawerOpen || menuDrawerOpen) {
    floatingIcons.classList.add('hide-with-opacity');
  } else {
    floatingIcons.classList.remove('hide-with-opacity');
  }
}

// Observe attribute changes on both drawers
const cartDrawer = document.querySelector('cart-drawer');
const menuDrawer = document.querySelector('menu-drawer');

if (cartDrawer) {
  const observerCart = new MutationObserver(toggleWidgets);
  observerCart.observe(cartDrawer, { attributes: true });
}
if (menuDrawer) {
  const observerMenu = new MutationObserver(toggleWidgets);
  observerMenu.observe(menuDrawer, { attributes: true });
}
// Fix scrollbar issue on mobile
(function() {
  function fixScrollbarWidthMobile() {
    const isMobile = window.innerWidth < 768;
    const currentWidth = window.getComputedStyle(document.documentElement)
      .getPropertyValue('--scrollbar-width').trim();
    
    if (isMobile && currentWidth !== '0px') {
      console.log('🔧 Fixing --scrollbar-width on mobile');
      document.documentElement.style.setProperty('--scrollbar-width', '0px', 'important');
    }
  }

  // Run on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixScrollbarWidthMobile);
  } else {
    fixScrollbarWidthMobile();
  }

  // Run on resize (when switching viewport)
  window.addEventListener('resize', fixScrollbarWidthMobile);
  
  // Run when drawer opens (drawer sets scrollbar-width)
  document.addEventListener('cart-drawer:open', fixScrollbarWidthMobile);
  document.addEventListener('modal:open', fixScrollbarWidthMobile);
})();


// Initial check on page load
toggleWidgets();